import {useState} from 'react';
import useShareContent from '@src/Hooks/useShareContent';
import useGetLinkToShare from '@src/utils/useGetLinkToShare';
import {IVodItemFragmentFragment} from '@src/Api/Graphql/gql/types.generated';

export function useVodShare(vodItem?: IVodItemFragmentFragment) {
  const shareContent = useShareContent({screenSource: 'detail'});
  const {getLinkToShare} = useGetLinkToShare();
  const [isOpenDialogShare, setIsOpenDialogShare] = useState(false);
  const [linkToShare, setLinkToShare] = useState<string | undefined>(undefined);

  function handleShare() {
    if (vodItem && vodItem.url) {
      shareContent.share({
        __typename: vodItem.__typename,
        url: vodItem.url,
        message: vodItem.title,
        id: vodItem.id,
        category: vodItem.parent?.name,
        cover:
          vodItem.thumbnail && vodItem.thumbnail.url
            ? vodItem.thumbnail.url
            : '',
        description: vodItem.description || vodItem.shortDescription || '',
        title: vodItem.title,
        countryOfProduction: vodItem.productionCountry,
      });
      const link = getLinkToShare({
        param: {
          __typename: vodItem.__typename,
          id: vodItem.id,
          url: vodItem.url,
        } as any,
      });
      setLinkToShare(link);
      setIsOpenDialogShare(true);
    }
  }

  return {
    isOpenDialogShare,
    setIsOpenDialogShare,
    linkToShare,
    setLinkToShare,
    handleShare,
  };
}
